import { redirect, type LoaderFunctionArgs } from '@remix-run/node';
import { Link, Outlet } from '@remix-run/react';
import {
  createServerClient,
  parseCookieHeader,
  serializeCookieHeader,
} from '@supabase/ssr';

import Logo from '~/assets/Logo.svg';
import person from '~/assets/person.svg';
import { env } from '~/env/env';
import useTranslation from '~/i18n/i18n';
import { redirectPathnameAfterLogin } from '~/lib/utils/constants';

export async function loader({ request }: LoaderFunctionArgs) {
  const headers = new Headers();

  const supabase = createServerClient(
    env.SUPABASE_URL!,
    env.SUPABASE_ANON_KEY!,
    {
      cookies: {
        getAll() {
          return parseCookieHeader(request.headers.get('Cookie') ?? '');
        },
        setAll(cookiesToSet) {
          cookiesToSet.forEach(({ name, value, options }) =>
            headers.append(
              'Set-Cookie',
              serializeCookieHeader(name, value, options),
            ),
          );
        },
      },
    },
  );

  const {
    data: { user },
  } = await supabase.auth.getUser();

  const {
    data: { session },
  } = await supabase.auth.getSession();

  // If user is logged in redirect to dashboard
  if (session && user) return redirect(redirectPathnameAfterLogin);

  return null;
}

export default function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-full flex-col items-start justify-start gap-8">
      <div className="p-8 md:pb-4 md:pt-16">
        <Link to="/">
          <img
            src={Logo}
            alt={t('common.appName')}
            className="h-auto w-full dark:invert md:w-2/3"
          />
        </Link>
      </div>
      <div className="flex w-full grow flex-row items-start justify-between">
        <div className="flex h-full w-full p-8 md:w-1/2 md:pb-16 md:pt-8">
          <Outlet />
        </div>
        <div className="hidden h-full w-[50%] items-end justify-end pr-7 md:flex">
          <img
            src={person}
            alt="person"
            className="h-auto w-full dark:invert"
          />
        </div>
      </div>
    </div>
  );
}
